import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

interface AskAssociationContextValue {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

const AskAssociationContext = createContext<AskAssociationContextValue>({
  isOpen: false,
  open: () => {},
  close: () => {},
});

export const useAskAssociation = () => useContext(AskAssociationContext);

export const AskAssociationProvider: React.FC = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);

  const value = useMemo(() => ({ isOpen, open, close }), [isOpen, open, close]);

  return <AskAssociationContext.Provider value={value}>{children}</AskAssociationContext.Provider>;
};
